import { SearchFiltersType, SearchItemTypeEnum } from '@nauTypes/nausearchType';
import { BuildSearchRequestArgs, PostCriteria, ProfileCriteria, SearchApiRequest } from './searchType';

export const buildSearchRequest = ({
  message,
  filters,
  pageSize,
  searchAfterScore,
  searchAfterIdSort,
  typeId,
}: BuildSearchRequestArgs): SearchApiRequest => {
  const base: SearchApiRequest = {
    ...(message ? { message } : {}),
    pageSize,
    searchAfterIdSort,
    searchAfterScore,
    ...(typeId ? { typeId } : {}),
  };
  if (typeId === SearchItemTypeEnum.people) {
    const profileCriteria = buildProfileCriteria(filters);
    return profileCriteria
      ? {
          ...base,
          profileCriteria,
        }
      : base;
  }
  const postCriteria = buildPostCriteria(filters);
  return postCriteria
    ? {
        ...base,
        postCriteria,
      }
    : base;
};
export const buildProfileCriteria = (filters?: SearchFiltersType): ProfileCriteria | undefined => {
  if (!filters) return undefined;
  const profile: ProfileCriteria = {
    ...((filters.city || filters.cCity?.uref) && {
      address: {
        ...(filters.cCity?.uref && { cCity: filters.cCity.uref }),
        ...(filters.city && { city: filters.city }),
      },
    }),
    ...(filters.gender && { gender: filters.gender }),
    ...(filters.workplace && {
      laborActivity: {
        orgName: filters.workplace,
      },
    }),
  };
  return Object.keys(profile).length ? profile : undefined;
};

export const buildPostCriteria = (filters?: SearchFiltersType): PostCriteria | undefined => {
  if (!filters) return undefined;
  const post: PostCriteria = {
    ...(filters.author && { author: filters.author }),
    ...(filters.keywords && { keywords: filters.keywords }),
    ...(filters.startYear && { startYear: filters.startYear }),
    ...(filters.endYear && { endYear: filters.endYear }),
    ...(filters.startPublicationDate && { startPublicationDate: filters.startPublicationDate }),
    ...(filters.endPublicationDate && { endPublicationDate: filters.endPublicationDate }),
  };
  return Object.keys(post).length ? post : undefined;
};